import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-legend" }
const _hoisted_2 = { class: "map-legend__title" }

import {MAP_DISPLAY_PARAMS_LABELS, MapDisplayParamsKey} from "@/composables/constants/params";

interface MapLegendProps {
  paramName: MapDisplayParamsKey;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MapLegend',
  props: {
    paramName: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(MAP_DISPLAY_PARAMS_LABELS)[__props.paramName]), 1),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"map-legend__list\" data-v-b56cfb3e><div class=\"map-legend__item\" data-v-b56cfb3e><div class=\"map-legend__square map-legend__square--green\" data-v-b56cfb3e></div> Отрицательная динамика к АППГ </div><div class=\"map-legend__item\" data-v-b56cfb3e><div class=\"map-legend__square map-legend__square--red\" data-v-b56cfb3e></div> Положительная динамика к АППГ </div></div>", 1))
  ]))
}
}

})